var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"pay-box"},[_c('div',{staticClass:"pay-tag-box"},[_c('h2',[_vm._v("订单状态："+_vm._s(_vm.orderStatus[_vm.msg]))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }